module.exports = __webpack_public_path__ + "static/media/amazon_banner.e5fa82f9.png";